import PropTypes from 'prop-types';

import { PaymentMethodsProvider } from '@zenbusiness/application-commons-ecommerce';
import useMountEffect from '@zenbusiness/application-commons-hooks/useMountEffect';
import { LoadingZone } from '@zenbusiness/application-commons-loading';
import Stack from '@zenbusiness/zui/Stack';

import { useNotification } from '#client/App/NotificationManager';
import Trustpilot from '#client/components/Trustpilot';
import useCheckoutStarted from '#client/hooks/clickstream/useCheckoutStarted';
import TwoColumnLayout from '#client/layouts/TwoColumnLayout';

import { CardRoot as Card } from './Checkout.style';
import CheckoutCardList from './components/CheckoutCardList';
import Faqs from './components/Faqs';
import Header from './components/Header';
import ListCallout from './components/ListCallout';
import TaxesCallout from './components/TaxesCallout';
import { CheckoutProvider } from './hooks/useCheckoutContext';
import { useCheckoutSteps } from './hooks/useCheckoutSteps';

const MESSAGE_KEY = 'shopping.page.checkout';

function CheckoutPage({ slotProps }) {
  const { onError } = useNotification();
  const trackCheckoutStarted = useCheckoutStarted();
  const stepOrder = useCheckoutSteps();

  const { businessCardProps, listCallout, pageHeader } = slotProps || {};
  const { showSubtitle = true } = pageHeader || {};

  useMountEffect(() => {
    trackCheckoutStarted({ totalSteps: stepOrder.length });
  });

  return (
    <CheckoutProvider>
      <PaymentMethodsProvider onError={onError}>
        <LoadingZone bubble loadId="Checkout" timeout={10000}>
          <TwoColumnLayout>
            <TwoColumnLayout.SmallColumn>
              <Header messageKey={MESSAGE_KEY} showSubtitle={showSubtitle} />
              <CheckoutCardList businessCardProps={businessCardProps} />
            </TwoColumnLayout.SmallColumn>
            <TwoColumnLayout.LargeColumn>
              <Stack spacing={2} top={64}>
                <Stack display={{ xs: 'none', md: 'flex' }} spacing={2}>
                  <Card size="lg">
                    <ListCallout {...listCallout} />
                    <TaxesCallout />
                  </Card>
                  <Trustpilot />
                </Stack>
                <Faqs messageKey={MESSAGE_KEY} />
              </Stack>
            </TwoColumnLayout.LargeColumn>
          </TwoColumnLayout>
        </LoadingZone>
      </PaymentMethodsProvider>
    </CheckoutProvider>
  );
}

CheckoutPage.propTypes = {
  slotProps: PropTypes.shape({
    businessCardProps: PropTypes.shape({
      businessInfoFields: PropTypes.object,
      contactInfoFields: PropTypes.object
    }),
    listCallout: PropTypes.shape({
      showFilingGuarantee: PropTypes.bool,
      showMoneyBack: PropTypes.bool,
      showSupport: PropTypes.bool
    }),
    pageHeaader: PropTypes.shape({
      showSubtitle: PropTypes.bool
    })
  })
};

export default CheckoutPage;
